import SvgIcon from '~/components/common/svg-icon.vue';
import LabelItem from '~/components/common/label-item.vue';
import CommonTitle from '~/components/common/common-title.vue';
import LabelContainer from '~/components/common/label-container.vue';
import DataBox from '~/components/common/data-box.vue';
import DataForm from "~/components/common/data-form.vue";
/**
 * 注册全局自定义组件
 */
export var registerComponent = function (Vue) {
    Vue.component('svg-icon', SvgIcon);
    Vue.component('label-item', LabelItem);
    Vue.component('label-container', LabelContainer);
    Vue.component('data-box', DataBox);
    Vue.component('data-form', DataForm);
    Vue.component('common-title', CommonTitle);
};
